<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="clients-grid">

            <div v-masonry transition-duration="0.3s" item-selector=".sorting-item" v-if="deal_count > 0" class="row sorting-container" id="clients-grid-1" >

                <div v-for="(deal,index) in deals" :key="index" class="col col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 sorting-item worlds family politics">

                    <div class="ui-block">

                        <article class="hentry post has-post-thumbnail">

                            <div class="post__author author vcard inline-items">
                                <img v-if="deal.business_logo !== null " :src="deal.business_logo" alt="author">

                                <div class="author-date">
                                    <router-link :to="'/profile/' + deal.business_username" class="h6 post__author-name fn"> {{ deal.business_name !== null ? deal.business_name : deal.business_username }} </router-link>
                                    <div class="post__date">
                                        <time class="published" datetime="2004-07-24T18:18">
                                            {{ dateString(deal.offer_deal_date) }}
                                        </time>
                                    </div>
                                </div>

                                <div style="width:100%;margin-top: 10px">
                                    <code class="bg-blue-light st"> {{ deal.fixture_home_team }} </code>
                                    <code class="bg-breez-light st"> {{ deal.fixture_away_team }} </code>
                                </div>

                            </div>

                            <h4 style="padding: 0 20px;text-decoration: underline;text-transform: capitalize">{{ deal.offer_name }}</h4>

                            <p>
                                <span style="width: 100%" v-if="deal.offer_link">
                                    <a target="_blank" :href="deal.offer_link">{{ deal.offer_link }}</a>
                                    <br><br>
                                </span>
                                {{ deal.offer_description !== null ? $urlify(deal.offer_description) : '' }}
                            </p>

                            <div class="post-thumb">
                                <img v-if="deal.offer_file" :src="deal.offer_file" alt="photo">
                            </div>


                        </article>
                    </div>
                </div>

            </div>

              <div  v-else class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-3 text-center">
                  <div class="space">
                      <div class="space-sm"></div>
                  </div>
                  <div class="ui-block">
                      <div
                              class="ui-block-content text-center"
                              style="padding: 50px 23px; border-top:solid 4px #08ddc1"
                      >
                          <h4 class="title" style="font-weight:bold">Opps! no deal yet</h4>
                          <p>It appears there is no deal yet, for restaurants do check back later</p>
                      </div>
                  </div>
              </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Restaurants",
    data() {
        return {
            deal_count: "",
            deals: {},
            first_page_url: "",
            last_page_url: "",
            next_page_url: "",
            to: "",
            ffrom: "",
        }
    },
    mounted() {
      $("#site-header").addClass("switched");
      window.eventBus.$emit("sp","restaurants");

      // get page contents
        this.getSpecialPage('restaurant');

        $("title").html("Restaurants | " + this.$store.state.projectName);

      /* -----------------------------
          * End * Init Isotope sorting
      * ---------------------------*/

    },
    methods: {
        dateString(date) {
            return this.$getDateYear(date,{timestamp:true})
        },
        getSpecialPage(type) {
            this.axios.get('/deals/special/' + type)
                .then(response => {
                    // console.log(response.data.data.offers.data)
                    let responseData = response.data.data.offers;
                    this.deals = response.data.data.offers.data;
                    this.deal_count = response.data.data.count;
                    this.first_page_url = responseData.first_page_url;
                    this.last_page_url = responseData.last_page_url;
                    this.next_page_url = responseData.next_page_url;
                    this.to = responseData.to;
                    this.ffrom = responseData.from;
                })
                .catch(error => {
                    // console.log(error)
                    return error;
                })
        }
    }
  };
</script>

<style>
    .st {
        padding: 7px 10px;
        color: #fff !important;
    }
</style>
